import React, { useEffect, useState } from "react";
import './styles.css'
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from "../../../utils/AppConstants";
import { PLAN_PRICING } from "../../../utils/PricingPlan";

const LandingNavBar = props => {
    let navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { showHomeLink } = props

    const toggleMenu = () => {
        console.log("Hamburger clicked!");
        setIsMenuOpen(!isMenuOpen);
    };

    const handleHomeClick = () => {
        navigate(ROUTES.home)
    }

    const handleLoginClick = () => {
        navigate(ROUTES.businessLogin)
    }

    const handleContactUsClick = () => {
        navigate(ROUTES.contactUs)
    }

    const handleCreateAccountClick = () => {
        navigate(ROUTES.businessCreateAccount, {
            state: {
                startFreeTrail: true
            }
        })
    }

    const handleFeaturesClick = () => {
        navigate(ROUTES.featureList)
    }

    const handlePricingClick = () => {
        navigate(ROUTES.productPricing)
    }

    const handleStorefrontClick = () => {
        window.open('https://retail.togethra.com', '_blank')
    }

    return (
        <>
            <div className='lp-nav-header-row-container'>
                <div className="home-logo-parent-container">
                    <div className="home-logo-container">
                        <img src={require('../../../assets/logo_togethra_icon.png')} className="img" alt="logo" />
                    </div>
                </div>
                <div className={`lp-nav-header-row-item-container ${isMenuOpen ? 'show' : ''}`}>
                    {showHomeLink && <div className="lp-header-label" onClick={() => { handleHomeClick() }}>Home</div>}
                    <div className="lp-header-label" onClick={() => { handleStorefrontClick() }}>Retail</div>
                    <div className="lp-header-label" onClick={() => { handlePricingClick() }}>Pricing</div>
                    <div className="lp-header-label" onClick={() => { handleFeaturesClick() }}>What We Offer</div>
                    <div className="lp-header-label" onClick={() => { handleContactUsClick() }}>Contact Us</div>
                </div>
                <div className={`lp-nav-header-row-item-container ${isMenuOpen ? 'show' : ''}`}>
                    <div className="lp-header-login-btn" onClick={() => { handleLoginClick() }}>LOGIN</div>
                    <div className="lp-header-account-btn" onClick={() => { handleCreateAccountClick() }}>START FREE TRIAL</div>
                </div>
                <div className="lp-mobile-row-container">
                    <div className="lp-header-login-btn" onClick={() => { handleLoginClick() }}>Login</div>
                    {/* Hamburger Icon for mobile/tablet */}
                    {!isMenuOpen && <div className="hamburger-icon" onClick={toggleMenu}>
                        <img src={require('../../../assets/nav_header_open.png')} className="img" alt="img" />
                    </div>}
                    {isMenuOpen && <div className="hamburger-icon" onClick={toggleMenu}>
                        <img src={require('../../../assets/nav_header_close.png')} className="img" alt="img" />
                    </div>}
                </div>

                {/* Collapsible menu for mobile */}
                {isMenuOpen && (
                    <div className="mobile-menu">
                        {showHomeLink && <div className="lp-header-label-mv" onClick={() => { handleHomeClick() }}>Home</div>}
                        <div className="lp-header-label-mv" onClick={() => { handleStorefrontClick() }}>Retail</div>
                        <div className="lp-header-label-mv" onClick={() => { handlePricingClick() }}>Pricing</div>
                        <div className="lp-header-label-mv" onClick={() => { handleFeaturesClick() }}>What We Offer</div>
                        <div className="lp-header-label-mv" onClick={() => { handleContactUsClick() }}>Contact Us</div>
                        <div className="lp-header-account-btn mt-2 mb-2" onClick={() => { handleCreateAccountClick(handleCreateAccountClick) }}>START FREE TRIAL</div>
                    </div>
                )}
            </div>
        </>
    )
}

export default LandingNavBar